import { useEffect, useState } from "react";
import { AlertCircle } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/card";

export const NotFound = () => {
  const [timer, setTimer] = useState(10);
  const navigate = useNavigate();

  useEffect(() => {
    if (timer > 0) {
      const interval = setInterval(() => {
        setTimer((prevTimer) => prevTimer - 1);
      }, 1000);
      return () => clearInterval(interval);
    } else {
      navigate("/");
    }
  }, [timer, navigate]);
  return (
    <Card>
      <CardContent className="pt-6">
        <div className="w-full flex items-center justify-center py-20">
          <div className="flex gap-2 items-center">
            <AlertCircle className="size-8" />
            <div className="text-2xl font-bold">Page not found</div>
          </div>
        </div>
        <div className="flex items-center justify-center py-5">
          Redirecting to home page in {timer} seconds
        </div>
      </CardContent>
    </Card>
  );
};
